import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Departement } from 'src/app/shared/models/departement';

@Component({
	selector: 'app-departement-modal-ajout',
	templateUrl: './departement-modal-ajout.component.html',
	styleUrls: ['./departement-modal-ajout.component.scss']
})
export class DepartementModalAjoutComponent {
	NAME_PATTERN = '^[^0-9]+$';

	formEdit = new FormGroup({
		name: new FormControl('', [
			Validators.required,
			Validators.pattern(this.NAME_PATTERN)
		]),
		code: new FormControl('', [
			Validators.required
		])
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private logger: LogService
	) {}

	// ngOnInit(): void {}

	onSubmit() {
		this.isValidateButtonClicked = true;
		const departement = new Departement();
		departement.name = this.formEdit.get('name').value;
		departement.code = this.formEdit.get('code').value;
		this.facade.departementService.addDepartement(departement).subscribe({
			next: (succ) => {
				this.bsModalRef.hide();
				// this.isValidateButtonClicked=false;
			},
			error: (err) => {
				this.isValidateButtonClicked = false;
				this.facade.toastService.createHttpErrorToast(
					err.error.message ? err.error.message : '',
					err.status
				);
				this.logger.error(err);
			}
		});
	}

	get name() {
		return this.formEdit.get('name');
	}
	get code() {
		return this.formEdit.get('code');
	}
}
